import { injectAppHistory } from '@wolffun/app-manager';
import { reducers } from '../redux/reducers';
export const makeProfileInjector = ({
  history,
  store
}) => {
  injectAppHistory(history);
  store.injectReducer(reducers);
};